// Import and register all your controllers

import { application } from "./application"

// Import controllers manually
import MapController from "./map_controller"

// Register controllers
application.register("map", MapController)